import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { recoverArticle, recoverCollection, getTrash } from '../lib/knowledge-api'

export function trashQueryOptions(workspaceId: string) {
  return queryOptions({
    queryKey: ['trash', workspaceId] as const,
    queryFn: () => getTrash(workspaceId),
  })
}

export function useTrash(workspaceId: string, enabled = true) {
  return useQuery({
    ...trashQueryOptions(workspaceId),
    enabled,
  })
}

export function useRecoverArticle(workspaceId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => recoverArticle(workspaceId, id),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({ queryKey: trashQueryOptions(workspaceId).queryKey })
        queryClient.invalidateQueries({ queryKey: ['articles', workspaceId] })
      }
    },
  })
}

export function useRecoverCollection(workspaceId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => recoverCollection(workspaceId, id),
    onSuccess: (result) => {
      if (result.success) {
        queryClient.invalidateQueries({ queryKey: trashQueryOptions(workspaceId).queryKey })
        queryClient.invalidateQueries({ queryKey: ['collections', workspaceId] })
      }
    },
  })
}
